export default __webpack_public_path__ + "static/media/qrcode_demo.cb78bf10.svg";